// 261030 S12i — luồng 4 bước chỉ dừng ở «Duyệt tài sản» (cổng 2) và «Gen N video»: máy tự qua cổng 1 (cuối ①) và cổng 3 (cuối ③). THUẦN (không import antd).
// BE ghi bản duyệt của máy với `approval.by === 'SYSTEM:auto-gate'`; FE chỉ đọc để hiện chip «Máy đã tự duyệt» — nút duyệt tay chỉ còn khi chuỗi dừng vì lỗi máy không tự gỡ.
import { promptCostLineOf, PromptEstimate } from './workflowFourVideoUtils';

export const AUTO_GATE_BY = 'SYSTEM:auto-gate';
export type AutoGateStep = 'STEP1' | 'BOARD';
export interface AutoGateGatesLike { STEP1?: { verdict?: string; approval?: unknown } | null; ASSETS?: { promptEstimate?: PromptEstimate | null } | null; BOARD?: { verdict?: string; approval?: unknown } | null }

/** Cổng đang «đã duyệt» và bản duyệt hiện hành do MÁY ghi (không phải người). */
export function autoApprovedOf(gates: AutoGateGatesLike | null | undefined, step: AutoGateStep): boolean {
  const g = gates?.[step];
  const by = g && typeof g.approval === 'object' && g.approval ? (g.approval as { by?: unknown }).by : null;
  return g?.verdict === 'OK' && by === AUTO_GATE_BY;
}
const CHIP_TITLE: Record<AutoGateStep, string> = {
  STEP1: 'Bước ① chạy xong và không còn mục nào cần bạn quyết, nên máy đã tự duyệt cổng 1 và mở bước ② (tài sản).',
  BOARD: 'Bước ③ vẽ xong và không còn tấm lỗi / cũ, nên máy đã tự duyệt cổng 3 và viết prompt bước ④ (chưa gen video).',
};
export function autoGateChipOf(step: AutoGateStep): { text: string; title: string } { return { text: 'Máy đã tự duyệt', title: CHIP_TITLE[step] }; }

/** Ước ④ trong hộp «Duyệt cổng 2» (BE `gates.ASSETS.promptEstimate`): chỉ khi có video cần viết/viết lại prompt và có hash để xác nhận. */
export function gate2PromptEstimateOf(gates: AutoGateGatesLike | null | undefined): PromptEstimate | null {
  const e = gates?.ASSETS?.promptEstimate;
  return e && e.n > 0 && typeof e.hash === 'string' && e.hash ? e : null;
}
/** Dòng tổng ③ + ④ ở hộp cổng 2. `boardUsd` = ước ③ (có thể 0). Trả '' khi không có gì tốn tiền. */
export function gate2TotalLineOf(boardUsd: number | null | undefined, prompt: PromptEstimate | null | undefined): string {
  const b = typeof boardUsd === 'number' && Number.isFinite(boardUsd) && boardUsd > 0 ? boardUsd : 0;
  const p = prompt && prompt.usd > 0 ? prompt.usd : 0;
  const pMax = prompt ? (typeof prompt.usdMax === 'number' && prompt.usdMax > p ? prompt.usdMax : p) : 0;
  if (!(b + p > 0)) return '';
  const total = b + p;
  const max = b + pMax;
  const usd = (x: number) => '$' + x.toFixed(2);   // dựng chuỗi (như promptCostLineOf): hộp xác nhận cổng 2 nêu tiền để người biết mình đang duyệt gì — brief S12i
  return max > total + 1e-9 ? 'Tổng ③ + ④ ≈ ' + usd(total) + ' (tối đa ' + usd(max) + ' nếu máy phải viết lại)' : 'Tổng ③ + ④ ≈ ' + usd(total);
}
/** Các dòng mô tả phần ④ trong hộp cổng 2. */
export function gate2PromptLinesOf(prompt: PromptEstimate | null | undefined): { lead: string; cost: string } | null {
  if (!prompt || !(prompt.n > 0)) return null;
  return { lead: `Vẽ xong ③, máy tự duyệt cổng 3 rồi viết prompt cho ${prompt.n} video (chưa gen video).`, cost: promptCostLineOf(prompt) };
}
export const AUTO_GATE_GUIDANCE = 'Chỉ còn một chỗ bạn duyệt: tài sản (bước ②). Sau đó máy tự vẽ sơ đồ + storyboard và viết prompt, rồi dừng ở «Gen N video» — video luôn do bạn bấm.';
export const AUTO_GATE_STOPPED_TEXT: Record<AutoGateStep, string> = {
  STEP1: 'Cổng 1 chưa được duyệt. Máy chỉ tự duyệt khi bước ① vừa chạy xong và không còn mục nào cần bạn quyết — ở đây cần bạn xem rồi bấm duyệt.',
  BOARD: 'Cổng 3 chưa được duyệt. Máy chỉ tự duyệt khi bước ③ vừa vẽ xong sạch (không còn tấm lỗi / cũ) — ở đây cần bạn xem rồi bấm duyệt.',
};
